export default __webpack_public_path__ + "static/media/alarm.2a806950.svg";